import React from "react";
import { Routes, Route } from "react-router-dom"; 
import NewLandingPage from "./pages/New Features/New Landing Page/NewLandingPage"
import SchoolDetailsPage from "./pages/New Features/New Landing Page/SchoolDetailsPage";
import SchoolSearchResultsPage from "./pages/New Features/New Landing Page/SchoolSearchResultsPage";
import PrivacyPolicy from "./pages/New Features/New Landing Page/PrivacyPolicy";

const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/school_details/:id" element={<SchoolDetailsPage />} /> 
        <Route path="/school_search_results" element={<SchoolSearchResultsPage />} /> 
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </div>
  );
};

export default App;
